module.exports = __webpack_public_path__ + "img/ep-B-dosis.3a0e2da9.jpg";